import React from "react";
import "./Orange_Btn.css";
import { Button } from "react-bootstrap";

function Orange_Btn({btnText,onClick,type}) {
  return (
    <>
      <section className="Orange_Btn_holder">
        <Button className="Orange_Btn" type={type} onClick={onClick}>{btnText}</Button>
      </section>
    </>
  );
}

export default Orange_Btn;
